import {Component, OnInit, HostBinding} from '@angular/core';
import {GlobalService} from '../../global/global.service';
import {HttpService} from '../../auth/http.client.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public version = 'v0.1.0';
  public build = 0;
  public developerDocLink = environment.devDocUrl;
  public year = new Date().getFullYear();
  // @HostBinding('style.position') position = 'fixed';
  constructor(private globalService: GlobalService, private http: HttpService) { }

  showTermsOfUse() {
    this.globalService.nextPopupState(true);
  }


  ngOnInit() {
    this.getVersion();

  }

  getVersion() {
    this.http.get('./app.json')
      .subscribe( (response) => {
          let appDetails = response.json();
          this.version = appDetails.version;
          this.build = appDetails.build;

        },
        (error) => {});
  }
}



// WEBPACK FOOTER //
// ./src/app/core/footer/footer.component.ts